import React, { SVGProps } from 'react';

const CompletedIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 12 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M11.7225 1.5819L4.22253 9.0819C4.17899 9.12548 4.12729 9.16006 4.07039 9.18365C4.01348 9.20724 3.95249 9.21938 3.89089 9.21938C3.82928 9.21938 3.76829 9.20724 3.71138 9.18365C3.65448 9.16006 3.60278 9.12548 3.55925 9.0819L0.277995 5.80065C0.190038 5.7127 0.140625 5.5934 0.140625 5.46901C0.140625 5.34462 0.190038 5.22533 0.277995 5.13737C0.365952 5.04941 0.485246 5 0.609636 5C0.734025 5 0.85332 5.04941 0.941276 5.13737L3.89089 8.08757L11.0592 0.91862C11.1472 0.830663 11.2665 0.78125 11.3909 0.78125C11.5153 0.78125 11.6346 0.830663 11.7225 0.91862C11.8105 1.00658 11.8599 1.12587 11.8599 1.25026C11.8599 1.37465 11.8105 1.49394 11.7225 1.5819Z"
				fill="#00FFA3"
			/>
		</svg>
	);
};

export default CompletedIcon;
